export default __webpack_public_path__ + "static/media/painscale_2.f5d851b3.png";